import { useEffect, useState } from "react";
import { Button, MenuItem, InputLabel, Select, Card, Grid, Typography, Autocomplete, Radio, TextField, Box, Switch, Backdrop, CircularProgress, Modal, FormControl, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Checkbox } from "@mui/material"
import axios from 'axios';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import { BarGraph, ScatterPlot, LineChart, MultiLineChart, ScatterPlotWithoutData, ErrorHistogram } from "../../utils/Graph";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, OutlinedInput, ListItemText } from '@mui/material';
import { fetchAPI } from "../../utils/ApiService";
import { icons, cardHeader, buttonStyle, iconStyle, cardStyle, butttonWithIcon, secondary_icon, card_icon, subHeaderStyle, textStyle, modalstyle, headerStyle } from "../../styles/sharedStyles";
import { useImperativeHandle } from "react";
import { forwardRef } from "react";
import React from 'react';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { CustomizedSnackbar } from "../../utils/CustomizedSnackbar";
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';
import DeleteIcon from '@mui/icons-material/Delete'
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import AirIcon from '@mui/icons-material/Air';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AllOutIcon from '@mui/icons-material/AllOut';
import ArticleIcon from '@mui/icons-material/Article';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import CycloneIcon from '@mui/icons-material/Cyclone';
import SummarizeIcon from '@mui/icons-material/Summarize';
import DataObjectIcon from '@mui/icons-material/DataObject';
import MemoryIcon from '@mui/icons-material/Memory';
import ViewListIcon from '@mui/icons-material/ViewList';


export const PlotsForm = forwardRef((props, ref) => {
    const [problemFormulationList, setProblemFormulationList] = useState([]);
    const [surrogateModelList, setsurrogateModelList] = useState([]);
    const [boundaryCondition, setBoundaryCondition] = useState("");
    const [surrogateModelName, setSurrogateModelName] = useState("");
    const [uniqueName, setUniqueName] = useState("");
    const [problemFormulation, setProblemFormulation] = useState("");
    const [selectedModel, setSelectedModel] = useState("");
    const [isEDAReportAvailable, setIsEDAReportAvailable] = useState(false)
    const [targetModels, setTargetModels] = useState([]);
    const [boundaryMin, setBoundaryMin] = useState();
    const [boundaryMax, setBoundaryMax] = useState();
    const [kernel, setKernel] = useState("");
    const [errorTable, setErrorTable] = useState("");
    const [geometryInputs, setGeometryInputs] = useState([]);
    const [inputConstraints, setInputConstraints] = useState([]);
    const [outputConstraints, setOutputConstraints] = useState([]);
    const [outputVariables, setoutputVariables] = useState([]);
    const [targetProblems, setTargetProblems] = useState([]);
    const [loadopen, setLoadpen] = useState(false);
    const [geometryValues, setGeometryValues] = useState({});
    const [modelDetails, setModelDetails] = useState([]);
    const [metaData, setMetaData] = useState([]);
    const [problemFiles, setProblemFiles] = useState([]);
    const [openProblemAlert, setopenProblemAlert] = useState(false);
    const [openModelAlert, setOpenModelAlert] = useState(false);
    const [exportableModels, setExportableModels] = useState([]);
    const [selectedExportModels, setSelectedExportModels] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [severityType, setSeverityType] = useState("success");
    const [validatedSelection, setValidatedSelection] = useState()


    const handleDeleteClick = () => {
        setopenProblemAlert(true);
    };

    const handleConfirmDelete = () => {
        DeleteProblemFormulation();
        setopenProblemAlert(false);
    };

    const handleCancelDelete = () => {
        setopenProblemAlert(false);
    };

    const handleDeleteModelClick = () => {
        setOpenModelAlert(true);
    };

    const handleConfirmModelDelete = () => {
        DeleteSurrogateModel();
        setOpenModelAlert(false);
    };

    const handleCancelModelDelete = () => {
        setOpenModelAlert(false);
    };

    const downloadEDAReport = async () => {
        setLoadpen(true)
        const payload = {
            problemName: problemFormulation
        }

        try {
            const presignedResponse = await fetchAPI.post('/eda_pre_signed_url', payload, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                }
            });

            if (presignedResponse.status === 204 || presignedResponse.status === 200) {
                console.log(presignedResponse.data.url)

                if (presignedResponse.data) {
                    // window.location.assign(presignedResponse.data.url);
                    const downloadUrl = presignedResponse.data.url
                    const fileName = presignedResponse.data.fileName

                    const fileResponse = await fetch(downloadUrl);
                    const blob = await fileResponse.blob();

                    const blobUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.setAttribute('download', fileName); // Suggests filename
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(blobUrl);


                } else {
                    console.error("Error fetching pre-singed url. ")

                }

            } else {
                console.error("Unexpected response status:", presignedResponse.status);

            }
            setLoadpen(false)

        } catch (error) {
            console.error('Error while downloading the file:', error);

            const errorMessage = error.response?.data?.message || 'Something went wrong';
            console.error('Error while downloading the file:', errorMessage);

            setSnackbarMsg(errorMessage);
            setSeverityType("error");
            setSnackbarOpen(true)
            setLoadpen(false)
        }

    }

    const getProblemList = async () => {
        try {
            setLoadpen(true)
            const token = localStorage.getItem("msal.idtoken");
            const { data: { data: problemList } } = await fetchAPI.get("/get_problem_formulation_list", {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            setProblemFormulationList(problemList);
            setLoadpen(false)
        } catch (error) {
            setLoadpen(false)
            console.error("Failed to fetch problem list:", error);
        }
    };
    const getMetaData = async (problemName) => {
        setLoadpen(true);
        setSnackbarOpen(false)
        setExportableModels([]);
        setModelDetails([]);
        setSelectedModel("");
        setIsEDAReportAvailable(false)
        setMetaData([]);
        setProblemFiles([]);
        setSelectedExportModels([])


        try {
            const token = localStorage.getItem("msal.idtoken");
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            };

            const [problemRes, modalRes] = await Promise.all([
                fetchAPI.post("/get_problem_info", { problemName }, { headers }),
                fetchAPI.post("/get_models_list", { problemName }, { headers }),
            ]);

            const problemData = problemRes?.data?.data;
            const modalsList = modalRes?.data?.data;
            console.log(problemData);
            console.log("ProblemData");
            console.log(modalsList);
            setTargetModels(modalsList);

            const inputs = problemData?.inputs || [];
            const boundary = problemData?.loaded_boundary || [];
            const outputs = problemData?.output_variables || [];
            const inputConstraints = problemData?.constraints.input || [];
            const outputConstraints = problemData?.constraints.output || [];
            const jsonFile = problemData?.json_file || [];
            const pklFile = problemData?.pkl_file || [];
            const generated_surrogate_files = problemData?.generated_surrogate_files || [];
            const surrogate_files = problemData?.surrogate_files || [];
            const report_generated = problemData?.report_generated;
            const report_url = problemData?.report_url;
            setIsEDAReportAvailable(report_generated);
            setGeometryInputs(inputs);
            setBoundaryCondition(boundary);
            setoutputVariables(outputs);
            setInputConstraints(inputConstraints)
            setOutputConstraints(outputConstraints)
            const allFiles = [
                ...(jsonFile ? [jsonFile] : []),
                ...(pklFile ? [pklFile] : []),
                ...generated_surrogate_files,
                ...surrogate_files
            ].filter(Boolean);
            setProblemFiles(allFiles);
            console.log(problemFiles)

            const metadataObj = {
                inputs: inputs.join(', '),
                boundary: Array.isArray(boundary) ? boundary.join(', ') : boundary,
                outputs: outputs.join(', '),
                inputConstraints: Array.isArray(inputConstraints) ? inputConstraints.join(', ') : inputConstraints,
                outputConstraints: Array.isArray(outputConstraints) ? outputConstraints.join(', ') : outputConstraints
            };

            setMetaData(metadataObj);
            if(problemName != ""){
                setSnackbarMsg(`Problem "${problemName}" details fetched successfully`)
                setSeverityType("success")
            }
        } catch (error) {
            console.error("Failed to fetch metadata:", error.response?.data?.message);
            setSnackbarMsg(`Error: ${error.response?.data?.message || error}`)
            setSeverityType("error")
            setSnackbarOpen(true)
        } finally {
            setLoadpen(false);
            setSnackbarOpen(true)

        }
    };

    const handleProblemFormulationChange = (event, newValue) => {
        console.log(`Checking if new value is okay ${newValue} ${event}`)
        if (newValue==null) {
        }
        else {
            setProblemFormulation(newValue)
            setSurrogateModelName('')
            setUniqueName(`${newValue}_`)
            getMetaData(newValue)
        }
    };

    const handleModelChange = async (event) => {
        const selectedModel = event.target.value;
        setSelectedModel(selectedModel);
        setLoadpen(true);
        setSnackbarOpen(false);


        try {
            const token = localStorage.getItem("msal.idtoken");
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            };

            const payload = {
                problem_and_model_name: selectedModel
            };

            const response = await fetchAPI.post("/get_model_info", payload, { headers });

            const { kernel_name, error_table, output_var } = response.data.data;

            setKernel(kernel_name);
            setErrorTable(error_table);

            // const filteredOutputVariables = outputVariables.filter(variable =>
            //     selectedModel.includes(variable)
            // );
            const modelDataObj = {
                model_name: selectedModel,
                kernel: kernel_name,
                error_table: error_table,
                outputVariables: output_var
            };

            setModelDetails(modelDataObj);
            setSnackbarMsg(`Model "${selectedModel}" details fetched successfully`);
            setSeverityType("success");


        } catch (error) {
            console.error("Failed to fetch model info:", error);
        } finally {
            setLoadpen(false);
            setSnackbarOpen(true)

        }
    };



    const DeleteProblemFormulation = async () => {
        setLoadpen(true);
        setSnackbarOpen(false)

        try {
            const token = localStorage.getItem("msal.idtoken");
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            };

            const payload = {
                problemName: problemFormulation
            };

            const response = await fetchAPI.post("/delete_problem_formulation", payload, { headers });

            if (response.status === 200) {
                setProblemFiles(["All problem formulation files have been deleted"]);
                setProblemFormulation("");
                setMetaData({});
                getProblemList();
                setSnackbarMsg(`Problem "${problemFormulation}" formulation files deleted successfully`)
                setSeverityType("success")
            }
        } catch (error) {
            console.error("Failed to delete problem formulation:", error);
        } finally {
            setLoadpen(false);
            setSnackbarOpen(true);
            getMetaData("");
        }
    };


    const DeleteSurrogateModel = async () => {
        setLoadpen(true);
        setSnackbarOpen(false);

        try {
            const token = localStorage.getItem("msal.idtoken");
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            };

            const payload = {
                problemName: problemFormulation,
                modelName: selectedModel
            };

            const response = await fetchAPI.post("/delete_surrogate_model", payload, { headers });

            if (response.status === 200) {
                setModelDetails({ deletionInfo: `Model ${selectedModel} deleted successfully` });
                setSelectedModel("");
                getMetaData(problemFormulation);
                setSnackbarMsg(`Model "${selectedModel}" deleted successfully`);
                setSeverityType("success");
            }
        } catch (error) {
            console.error("Failed to delete surrogate model:", error);
        } finally {
            setLoadpen(false);
            setSnackbarOpen(true);

        }
    };




    const ExportToSet = async () => {
        setLoadpen(true);
        setSnackbarOpen(false);
        try {
            const token = localStorage.getItem("msal.idtoken");
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            };

            const payload = {
                problemName: problemFormulation
            };

            const response = await fetchAPI.post("/export_selected_models", payload, { headers });

            if (response.status === 200) {
                const models = response.data.models;
                setExportableModels(models);
                if(models.length > 0) {
                    setSnackbarMsg(`Models for problem "${problemFormulation}" fetched successfully`)
                    setSeverityType("success")
                } else {
                    setSnackbarMsg(`No models available for problem "${problemFormulation}"`)
                    setSeverityType("warning");
                }
                
            }
        } catch (error) {
            console.error("Failed to export to SET:", error);
        } finally {
            setLoadpen(false);
            setSnackbarOpen(true);
        }
    };


    const handleModelSelection = (event, model) => {
        setSelectedExportModels(prevSelected => {
            const newSelection = event.target.checked
                ? [...prevSelected, model]
                : prevSelected.filter(m => m !== model);

            validateModelSelection(newSelection);

            return newSelection;
        });
    };

    const validateModelSelection = () => {
    setSnackbarOpen(false);
    const modelMap = {};
    let warningMessage = '';

    selectedExportModels.forEach(model => {
        const filteredOutputVariables = outputVariables.filter(variable =>
                model.includes(variable)
            );
        if (modelMap[filteredOutputVariables]) {
            warningMessage = `More than one model selected for ${filteredOutputVariables}`;
        } else {
            modelMap[filteredOutputVariables] = true;
        }
        console.log(modelMap)
    });

    if (warningMessage) {
        setSnackbarMsg(warningMessage);
        setSeverityType("warning");
        setSnackbarOpen(true);
        setValidatedSelection(false)
        return false;
    }
    setValidatedSelection(true)
    return true;
};



    useEffect(() => {
        validateModelSelection();
    }, [selectedExportModels]);

const downloadSelectedModel = async () => {
    setSnackbarOpen(false);
    
    if (!validateModelSelection()) {
        setLoadpen(false);
        return;
    }
    setLoadpen(true);
    
    try {
        const token = localStorage.getItem("msal.idtoken");
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        };

        const modelList = selectedExportModels;

        const payload = {
            problemName: problemFormulation,
            modelNames: modelList
        };

        const response = await fetchAPI.post("/download_selected_models", payload, { headers });

        if (response.status === 200 && response.data.presigned_url) {
            window.location.href = response.data.presigned_url;
            setSnackbarMsg("Download started successfully");
            setSeverityType("success");
            setLoadpen(false);
            setSnackbarOpen(true);
        } else if(response.status === 202){
            console.log("Still processing, starting polling...");
            pollForStatus(problemFormulation);
        } 
    } catch (error) {
        console.error("Failed to download selected model:", error);
        const errorMessage = error.response?.data?.detail || error.message || "An unknown error occurred";
        setSnackbarMsg(`Error: ${errorMessage}`);
        setSeverityType("error");
        setLoadpen(false);
        setSnackbarOpen(true);
    }
};

const pollForStatus = async (problemName) => {
    const poll = async () => {
        try {
            const token = localStorage.getItem("msal.idtoken");
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            };
            const response = await fetchAPI.post("/download_stats", { problemName }, { headers });
            
            if (response.status === 200) {
                if (response.data.data.presigned_url) {
                    window.location.href = response.data.data.presigned_url;
                    setSnackbarMsg("Download started successfully");
                    setSeverityType("success");
                    setSnackbarOpen(true);
                    setLoadpen(false);
                    return; 
                }
                setSnackbarMsg("Processing completed, but no download URL available");
                setSeverityType("warning");
                setSnackbarOpen(true);
                setLoadpen(false);
                return;
            }
            
            setTimeout(poll, 4000);
        } catch (error) {
            console.error("Error while polling for download status:", error);
            setSnackbarMsg("Error while polling for download status: " + (error.message || "Unknown error"));
            setSeverityType("error");
            setSnackbarOpen(true);
            setLoadpen(false);
        }
    };

    poll();
};







    useEffect(() => {
        getProblemList();
    }, []);


    return (
        <>
            <Card variant="outlined" sx={[cardStyle]}>
                <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography sx={[cardHeader , {marginBottom: "0px",}]}>View/Delete problem formulations and associated models</Typography>

                    {/* <span> <Switch onChange={handleEDA} checked={EDA}></Switch> Generate EDA Report</span> */}

                </Grid>


                <Box sx={{ width: '100%' }}>
                    {/* Row 1: Input 1 + Switch */}
                    <Grid sx={{ mb: 3 }}>
                        <Grid size={3}>
                            <FormControl fullWidth sx={{ mt: 2 }}>
                                <Autocomplete
                                    id="problem-formulation-autocomplete"
                                    options={problemFormulationList || []}
                                    value={problemFormulation || null}
                                    onChange={handleProblemFormulationChange}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select problem formulation"
                                            variant="outlined"
                                            placeholder="Search problem formulation"
                                        />
                                    )}
                                    filterOptions={(options, { inputValue }) => {
                                        return options.filter(option =>
                                            option.toLowerCase().includes(inputValue.toLowerCase())
                                        );
                                    }}
                                    isOptionEqualToValue={(option, value) => option === value}
                                    clearOnEscape
                                    selectOnFocus
                                    handleHomeEndKeys
                                />
                            </FormControl>
                            {/* <Tooltip title="This is the data shown on hover">
                            <Button>Hover me</Button>
                        </Tooltip> */}
                        </Grid>
                    </Grid>

                    {/* Row 2: Input 2 + Button */}
                    <Box
                        display="flex"
                        flexWrap="wrap"
                        gap={2}
                        justifyContent="space-between"
                    >

                        <Card
                            sx={{
                                // mt: 1,
                                flex: '1 1 calc(45% - 8px)',
                                minWidth: 300,
                                // p: 1,
                                padding: "15px",
                                height: (geometryInputs.length > 0 || boundaryCondition || outputVariables.length > 0) ? 205 : 'fit-content',
                                maxHeight: 205,
                                overflow: 'auto',
                                border: "none",
                                boxShadow: "0 1px 8px #d1dcf9",
                                borderRadius: "14px"
                            }}
                            variant="outlined"
                        >

                            {metaData && (metaData.inputs || metaData.boundary || metaData.outputs || metaData.inputConstraints || metaData.outputConstraints) ? (
                                <>
                                <Typography fontWeight="fontWeightBold" sx={[{ mb: 2 }, headerStyle]}>Problem formulation details</Typography>

                                        <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                            <AirIcon sx={[card_icon, { color: "#008cff" }]} />
                                            <span style={{ whiteSpace: "nowrap", margin: "0px 5px"}} fontWeight="fontWeightBold">Geometry Inputs: </span>
                                            <span style={textStyle}> {metaData.inputs || "[]"}</span>
                                            
                                        </Typography>

                                        <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                            <AnalyticsIcon sx={[card_icon, { color: "#e59128" }]} />
                                            <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Boundary Condition: </span>
                                            <span style={textStyle}> {metaData.boundary || "[]"}</span>
                                        </Typography>

                                        <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                            <CycloneIcon sx={[card_icon, { color: "#1daa07" }]} />
                                            <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Output Variables: </span>
                                            <span style={textStyle}> {metaData.outputs || "[]"}</span>
                                        </Typography>

                                        <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                            <ArticleIcon sx={[card_icon, { color: "#e0ae14" }]} />
                                            <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Input Constraints: </span>
                                            <span style={textStyle}> {metaData.inputConstraints || "[]"}</span>
                                        </Typography>

                                        <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                            <ArticleIcon sx={[card_icon, { color: "#e0ae14" }]} />
                                            <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Output Constraints: </span>
                                            <span style={textStyle}> {metaData.outputConstraints || "[]"}</span>
                                        </Typography>

                                    {isEDAReportAvailable ? (
                                        <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                            <SummarizeIcon sx={[card_icon, { color: "#149ce0ff" }]}/>
                                            <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Download EDA Report: </span>
                                            <Box component="span" sx={{ display: "inline-flex", alignItems: "center", ml: 0}}>
                                                <Box sx={[butttonWithIcon, {
                                                    backgroundColor: "#dbdddb75",
                                                    "&:hover": {
                                                        backgroundColor: "#babdba75",
                                                    },
                                                    transform: "translateY(-12px)"
                                                }]}>
                                                    <DownloadForOfflineIcon sx={[secondary_icon, { color: "#47a00a" }]} onClick={downloadEDAReport} />
                                                </Box>
                                            </Box>
                                        </Typography>
                                    ) : (
                                        <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                            <SummarizeIcon sx={[card_icon, { color: "#149ce0ff" }]}/>
                                            <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>EDA Report: </span>
                                            <span style={textStyle}>Report not generated</span>
                                        </Typography>
                                    )}
                                </>
                            ) : (
                                <Typography color="text.secondary">Select problem formulation</Typography>
                            )}
                        </Card>
                        <Card
                            sx={{
                                // mt: 1,
                                flex: '1 1 calc(45% - 8px)',
                                minWidth: 300,
                                // p: 1,
                                padding: "15px",
                                height: (geometryInputs.length > 0 || boundaryCondition || outputVariables.length > 0) ? 205 : 'fit-content',
                                maxHeight: 205,
                                overflow: 'auto',
                                border: "none",
                                boxShadow: "0 1px 8px #d1dcf9",
                                borderRadius: "14px"
                            }}
                            variant="outlined"
                        >

                            {problemFiles && problemFiles.some(file => file && typeof file === 'string' && file.trim() !== '') ? (
                                <>
                                    <Typography fontWeight="fontWeightBold" sx={[{ mb: 2 }, headerStyle]}>Problem formulation files</Typography>
                                    {problemFiles.filter(file => file && typeof file === 'string' && file.trim() !== '').map((file, index) => (
                                        <Typography key={index} sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                            <TextSnippetIcon sx={[card_icon, { color: "#e0ae14" }]}/>
                                            <span style={textStyle}>{file}</span>
                                        </Typography>
                                    ))}
                                </>
                            ) : (
                                <Typography color="text.secondary">No problem formulation files available</Typography>
                            )}

                        </Card>



                    </Box>
                </Box>

                <Box sx={{ mt: 3 }}>
                    <Button fullWidth variant="contained" disabled={!problemFormulation} sx={[buttonStyle, { flex: '1 1 30%', minWidth: 150 }]} onClick={() => handleDeleteClick()}><DeleteIcon sx={iconStyle} /><span>Delete Problem Formulation</span></Button>
                </Box>

                <Dialog
                    open={openProblemAlert}
                    onClose={handleCancelDelete}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Confirm Deletion"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to delete all problem formulation files?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCancelDelete}>Cancel</Button>
                        <Button onClick={handleConfirmDelete} autoFocus>
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>

            </Card>



            <Card variant="outlined" sx={[cardStyle]}>

                <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography sx={[cardHeader, { marginBottom: "auto", marginTop: "auto" }]}>
                        View/Delete surrogate model
                    </Typography>


                </Grid>

                <Box sx={{ width: '100%' }}>
                    {/* Row 1: Input 1 + Switch */}
                    <Grid sx={{ mb: 3, mt: 3 }}>
                        <Grid size={3}>
                            <FormControl fullWidth sx={{ flex: '1 1 45%', minWidth: 250 }}>
                                <InputLabel id="select-surrogate-label">Select surrogate model</InputLabel>
                                <Select
                                    labelId="select-surrogate-label"
                                    id="surrogate-checkbox"
                                    multiple={false}
                                    value={selectedModel}
                                    onChange={handleModelChange}
                                    input={<OutlinedInput label="Select Surrogate Model" />}

                                >
                                    {targetModels?.map((item) => (
                                        <MenuItem key={item} value={item} >
                                            <ListItemText primary={item} />
                                        </MenuItem>
                                    ))}

                                </Select>
                            </FormControl>
                            {/* <Tooltip title="This is the data shown on hover">
                            <Button>Hover me</Button>
                        </Tooltip> */}
                        </Grid>
                    </Grid>

                    {/* Row 2: Input 2 + Button */}
                    <Box
                        display="flex"
                        flexWrap="wrap"
                        gap={2}
                        justifyContent="space-between"
                    >

                        <Grid sx={{ flex: '1 1 30%', minWidth: 250 }}>
                            <Card
                            sx={{
                                // mt: 1,
                                flex: '1 1 calc(45% - 8px)',
                                minWidth: 300,
                                // p: 1,
                                padding: "15px",
                                height: (geometryInputs.length > 0 || boundaryCondition || outputVariables.length > 0) ? 205 : 'fit-content',
                                maxHeight: 205,
                                overflow: 'auto',
                                border: "none",
                                boxShadow: "0 1px 8px #d1dcf9",
                                borderRadius: "14px"
                            }}
                            variant="outlined"
                            >
                                <Typography fontWeight="fontWeightBold" sx={[{ mb: 2 }, headerStyle]}>Model details</Typography>
                                {modelDetails && Object.keys(modelDetails).length > 0 ? (
                                    <>
                                            <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                                <ModelTrainingIcon sx={[card_icon, { color: "#e59128" }]} />
                                                <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Model Name: </span>
                                                <span style={textStyle}> {modelDetails.model_name || "[]"}</span>
                                            </Typography>

                                            <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                                <DataObjectIcon sx={[card_icon, { color: "#008cff" }]} />
                                                <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Output Variables: </span>
                                                <span style={textStyle}> {modelDetails.outputVariables || ""}</span>
                                            </Typography>

                                            <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                                <MemoryIcon sx={[card_icon, { color: "#1daa07" }]} />
                                                <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Kernel: </span>
                                                <span style={textStyle}> {modelDetails.kernel || ""}</span>
                                            </Typography>

                                        {modelDetails.error_table && (
                                            <>
                                                <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}> 
                                                <ViewListIcon sx={[card_icon, { color: "#e0ae14" }]} />
                                                <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Error Table: </span>
                                                </Typography>
                                                <TableContainer component={Paper} sx={{ mb: 1 }}>
                                                    <Table size="medium" sx={{ '& .MuiTableCell-root': { fontSize: '15px', padding: '8px 16px', fontFamily: "'DM Sans', sans-serif", } }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ width: '20%', fontWeight: 'bold' }}>Dataset</TableCell>
                                                                <TableCell align="right" sx={{ width: '20%', fontWeight: 'bold' }}>MAPE (%)</TableCell>
                                                                <TableCell align="right" sx={{ width: '20%', fontWeight: 'bold' }}>RMSE (%)</TableCell>
                                                                <TableCell align="right" sx={{ width: '20%', fontWeight: 'bold' }}>RMSE</TableCell>
                                                                <TableCell align="right" sx={{ width: '20%', fontWeight: 'bold' }}>R2</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {modelDetails.error_table.map((row, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell component="th" scope="row">
                                                                        {row.Dataset}
                                                                    </TableCell>
                                                                    <TableCell align="right">{row["MAPE (%)"].toFixed(4)}</TableCell>
                                                                    <TableCell align="right">{row["RMSE (%)"].toFixed(4)}</TableCell>
                                                                    <TableCell align="right">{row.RMSE.toFixed(4)}</TableCell>
                                                                    <TableCell align="right">{row.R2.toFixed(4)}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </>
                                        )}

                                        {modelDetails.deletionInfo && (
                                            <Typography variant="body1" sx={{ mt: 2, mb: 2 }}>
                                                <Box component="span" fontWeight="bold">Message: </Box>
                                                {modelDetails.deletionInfo}
                                            </Typography>
                                        )}

                                    </>
                                ) : (
                                    <Typography variant="body1" color="text.secondary">Select a surrogate model</Typography>
                                )}
                            </Card>


                        </Grid>


                    </Box>


                </Box>
                <Box sx={{ mt: 3 }}>
                    <Button fullWidth variant="contained" disabled={!selectedModel} sx={[buttonStyle, { flex: '1 1 30%', minWidth: 150 }]} onClick={handleDeleteModelClick}><DeleteIcon sx={iconStyle} /> <span>Delete Surrogate Model</span></Button>
                </Box>
                <Dialog
                    open={openModelAlert}
                    onClose={handleCancelModelDelete}
                    aria-labelledby="model-alert-dialog-title"
                    aria-describedby="model-alert-dialog-description"
                >
                    <DialogTitle id="model-alert-dialog-title">
                        {"Confirm Surrogate Model Deletion"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="model-alert-dialog-description">
                            Are you sure you want to delete this surrogate model?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCancelModelDelete}>Cancel</Button>
                        <Button onClick={handleConfirmModelDelete} autoFocus>
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>


            </Card>


            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loadopen}
            >
                <CircularProgress size="4rem" />
            </Backdrop>
            {/* <Card variant="outlined" sx={[cardStyle]}>
                <Button fullWidth variant="contained" sx={[buttonStyle, { flex: '1 1 30%', minWidth: 150 }]} onClick={() => ExportToSet()}> <span>Export to SET</span></Button>
            </Card> */}


            <Card variant="outlined" sx={[cardStyle]}>

                <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography sx={[cardHeader, { marginBottom: "auto", marginTop: "auto" }]}>
                        Select model to export
                    </Typography>
                    <Button fullWidth variant="contained" disabled={!problemFormulation} sx={[buttonStyle, { width: "auto" }]} onClick={() => ExportToSet()}>
                        {/* <FileUploadRoundedIcon sx={iconStyle}/>  */}
                        <span>Export to SET</span></Button>


                </Grid>

                <Box sx={{ mt: 3, mb: 3 }}>
                    {exportableModels.length > 0 ? (
                        exportableModels.map((model, index) => (
                            <FormControlLabel
                                key={index}
                                control={
                                    <Checkbox
                                        checked={selectedExportModels.includes(model)}
                                        onChange={(e) => handleModelSelection(e, model)}
                                        value={model}
                                    />
                                }
                                label={model}
                            />
                        ))
                    ) : (
                        <Typography color="text.secondary">No exportable models available</Typography>
                    )}
                </Box>

                <Box sx={{ mt: 3 }}>
                    <Button
                        variant="contained"
                        sx={[buttonStyle, { flex: '1 1 30%', minWidth: 150 }]}
                        disabled={selectedExportModels.length === 0 || validatedSelection === false}
                        onClick={downloadSelectedModel}
                    >
                        <span><DownloadIcon sx={iconStyle} /></span>
                        <span>Download Selected Models</span>
                    </Button>
                </Box>


            </Card>



            <CustomizedSnackbar action={snackbarOpen} message={snackbarMsg} severityType={severityType} />

        </>
    )
}
)